import { useWebSocket, WebSocketMessage } from './WebSocketProvider';
import { useState, useCallback } from 'react';

/**
 * Servicio para enviar notificaciones a través de WebSockets
 */
export const useWebSocketNotificationService = () => {
  const { sendMessage, connectionState } = useWebSocket();
  const [isSending, setIsSending] = useState(false);
  
  /**
   * Envía una notificación a un usuario o grupo específico
   * @param targetId ID del usuario o grupo destinatario
   * @param message Contenido del mensaje
   * @param data Datos opcionales para incluir con la notificación
   * @returns Promesa que se resuelve cuando se envía la notificación
   */
  const sendNotification = useCallback(async <T = any>(
    targetId: string | number, 
    message: string,
    data?: T
  ): Promise<boolean> => {
    try {
      setIsSending(true);
      
      const notificationMessage: WebSocketMessage = {
        action: 'sendNotification',
        data: {
          targetId: targetId.toString(),
          message,
          payload: data || {}
        }
      };
      
      return sendMessage(notificationMessage);
    } catch (error) {
      console.error('Failed to send notification:', error);
      return false;
    } finally {
      setIsSending(false);
    }
  }, [sendMessage]);
  return {
    sendNotification,
    isSending,
    isConnected: connectionState === 'Connected'
  };
};
